import { gsap } from "gsap";

export function menuAnimations() {
  const header = document.querySelector(".site-header");

  if (header) {
    gsap.to(header, {
      y: 0,        // arriva in posizione normale
      opacity: 1,  // diventa visibile
      duration: 1.2,
      ease: "power2.out"
    });
  }
}